import Notification from '../../components/Notification/Notification';
import responseCodes from '../../constants/responseCodes';
import i18n from '../../i18n';
import * as networkService from '../../services/networkService';
import globalActionConstants from '../constants/globalActionConstants';
import networkActionConstants from '../constants/networkActionConstants';

const t = (key) => i18n.t(key, { ns: 'common' });

export const getContacts = (page, perPage, search, filters, sortby) => async (dispatch) => {
  dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_ON });
  try {
    const response = await networkService.getContacts(page, perPage, search, filters, sortby);
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: networkActionConstants.GET_CONTACTS, payload: response.data.payload });
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const getTags = (showSkeleton) => async (dispatch) => {
  if (showSkeleton) {
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_ON });
  } else {
    dispatch({ type: globalActionConstants.SET_LOADING_ON });
  }
  try {
    const response = await networkService.getTags();
    if (showSkeleton) {
      dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    } else {
      dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    }
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: networkActionConstants.GET_TAGS, payload: response.data.payload });
    } else {
      Notification.error(response.data.error.message);
    }
  } catch (err) {
    if (showSkeleton) {
      dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    } else {
      dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    }
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const createTag = (selectedContacts, tag, createTagSuccessCallback) => async (dispatch) => {
  dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_ON });
  try {
    const response = await networkService.createTag(selectedContacts, tag);
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      createTagSuccessCallback();
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const updateTag = (selectedContacts, tagsToAdd, tagsToDelete, createTagSuccessCallback) => async (dispatch) => {
  dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_ON });
  try {
    const response = await networkService.updateTag(selectedContacts, tagsToAdd, tagsToDelete);
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      createTagSuccessCallback();
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const setSearchTerm = (query) => async (dispatch) => {
  dispatch({ type: networkActionConstants.SET_SEARCH, payload: query });
};

export const setSortby = (value) => async (dispatch) => {
  dispatch({ type: networkActionConstants.SET_SORTBY, payload: value });
};

export const bulkDeleteContacts = (ids, successCallback) => async (dispatch) => {
  dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_ON });
  try {
    const response = await networkService.bulkDeleteContacts(ids);
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      successCallback();
      Notification.success(t('notifications.contactsDeleted'));
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const createUserContacts = (data, successCallback) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.createContact(data);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      successCallback();
      Notification.success(t('notifications.contactCreated'));
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const deleteUserContacts = (id, successCallback) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.destroyContact(id);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      successCallback();
      Notification.success(t('notifications.contactDeleted'));
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const updateUserContacts = (data, successCallback) => async (dispatch) => {
  dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_ON });
  try {
    const response = await networkService.updateContact(data);
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: networkActionConstants.UPDATE_USER_CONTACTS, payload: response.data.payload });
      successCallback();
      Notification.success(t('notifications.contactUpdated'));
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch (err) {
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const mergeContacts = (ids, mergeSuccessCallback) => async (dispatch) => {
  dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_ON });
  try {
    const response = await networkService.mergeContacts(ids);
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      mergeSuccessCallback();
      Notification.success(t('notifications.contactsMerged'));
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: networkActionConstants.SET_NETWORK_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const toggleConnectSync = (id, changeTo) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.toggleConnectSync(id, changeTo);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: networkActionConstants.TOGGLE_CONNECT_SYNC, payload: id });
      Notification.success(changeTo ? t('notifications.syncSourceTurnedOn') : t('notifications.syncSourceTurnedOff'));
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const deleteSync = (id) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.deleteSync(id);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: networkActionConstants.DELETE_SYNC, payload: id });
      Notification.success(t('notifications.syncSourceDeleted'));
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const getSyncData = () => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.getSyncData();
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: networkActionConstants.GET_SYNC_DATA, payload: response.data.payload });
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const uploadCSV = (file, successCallback) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.uploadCSV(file);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      successCallback?.(response.data.payload);
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const uploadVCF = (file, successCallback) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.uploadVCF(file);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      successCallback();
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const uploadMapping = (file, mappingObj, successCallback) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.uploadMapping(file, mappingObj);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      successCallback?.(response.data.payload);
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const importContacts = (file, mappingObj, time, successCallback) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.importContacts(file, mappingObj, time);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      successCallback?.(response.data.payload);
    } else {
      Notification.error(response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const fetchImportHistory = (source) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.fetchImportHistory(source);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: networkActionConstants.GET_IMPORT_HISTORY, payload: response.data.payload });
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const fetchImportHistoryCount = () => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.fetchImportHistoryCount();
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: networkActionConstants.GET_IMPORT_HISTORY_COUNT, payload: response.data.payload });
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};

export const removeImportHistory = (id) => async (dispatch) => {
  dispatch({ type: globalActionConstants.SET_LOADING_ON });
  try {
    const response = await networkService.removeImportHistory(id);
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    if (response.data.response_code === responseCodes.OK) {
      dispatch({ type: networkActionConstants.DELETE_IMPORT_HISTORY, payload: id });
      Notification.success(t('notifications.importHistoryDeleted'));
    } else {
      Notification.error(response.data.error.message || response.data.error);
    }
  } catch (err) {
    dispatch({ type: globalActionConstants.SET_LOADING_OFF });
    Notification.error(t('notifications.somethingWentWrong'));
  }
};
